import { Link } from "react-router-dom";
import styles from "./Articles.module.scss";

export const Article4 = () => {
  return (
    <div className={styles.articles__wrapper}>
      <Link to={"/articles"}>&#8592; Назад к статьям</Link>
      <h5 className={styles.articles__header}>
        Получить психологическую консультацию онлайн на основе виртуальных МАК
        (метафорические ассоциативные карты) PSYCards.
      </h5>
      <p className={styles.articles__pharagraph}>
        В последнее время, особенно активно в интернет-пространство внедряются
        различные услуги. Это не обошло стороной и психологическое
        консультирование. Появляется все больше ресурсов для осуществления
        консультации клиентов дистанционно.
      </p>
      <h5 className={styles.articles__header}>
        Получить психологическую консультацию
      </h5>
      <p className={styles.articles__pharagraph}>
        Эффективность психологической онлайн консультации или телепсихологии
        доказана временем. Услуги психолога, получаемые на очном приеме,
        практически ничем не отличаются от услуг онлайн специалиста. Психолог по
        Skype или Hangouts также с вниманием выслушает, задаст необходимые
        вопросы, окажет поддержку, поможет увидеть варианты решения проблем. И
        хотя, ограничения, конечно, есть, онлайн формат не менее эффективный
        способ психологической поддержки.
      </p>
      <p className={styles.articles__pharagraph}>
        <b>Получить психологическую консультацию</b> в онлайн режиме позволяет
        приложение PSYCards. С его помощью можно проводить психологические игры
        и обучение с использованием метафорических ассоциативных карт. Благодаря
        удобному для использования приложению психологическое консультирование
        онлайн стало на порядок проще, доступнее и обогатилось в способах помощи
        населению.
      </p>
      <h5 className={styles.articles__header}>
        Психологические консультации начать
      </h5>
      <p className={styles.articles__pharagraph}>
        Чтобы <b>психологические консультации начать</b>, необходимо преодолеть
        коммуникативные барьеры и неловкости первых минут встречи. Существует
        множество техник и упражнений психолога, которые помогают клиенту
        раскрыть свои мысли и чувства и увидеть верный путь к изменениям. Но
        самым популярным в психологическом сообществе средством для установления
        непринужденного контакта между психологом и клиентом стали МАК -
        метафорические ассоциативные карты. Нужная колода подбирается
        специалистом в зависимости от запроса клиента. В процессе консультации
        могут возникнуть вопросы или появится необходимость в просмотре
        вариантов развития событий. Тогда запрос корректируется и достаются
        новые карты.
      </p>
      <p className={styles.articles__pharagraph}>
        Достоинства МАК сложно переоценить. Образы метафорических карт через их
        обсуждение развивают диалог между психологом и клиентом, создают
        доверительную атмосферу, пробуждают интерес к самоисследованию и
        саморазвитию, служат в качестве инструмента, открывающего доступ к
        ресурсам человека.
      </p>
      <p className={styles.articles__pharagraph}>
        Карты прекрасно работают и онлайн. В отношение техник и методов работы
        успешно перенесенных в виртуальный мир МАК не произошло никаких
        серьезных изменений. Все, что выполняется психологом с реальными
        колодами: выбор колоды, выбор карты в открытую или в закрытую,
        перемещение карт по рабочему столу, переворот карты рубашкой вверх или
        вниз, произвольный поворот карт, а также масштабирование, с успехом
        реализуется в виртуальном поле PSYCards.
      </p>
      <h5 className={styles.articles__header}>
        Психологическая игра для консультации
      </h5>
      <p className={styles.articles__pharagraph}>
        Большое количество техник при оказании психологической помощи основаны
        на методологии игры.
      </p>
      <p className={styles.articles__pharagraph}>
        Психологическая трансформационная игра всегда проводится с учетом личных
        запросов клиента. Игровой подход позволяет сформировать атмосферу
        принятия и взаимодействия, что существенно для того, чтобы человек
        увидел себя с другого ракурса, с иной точки зрения. Психотерапия
        способствует выявлению привычных стратегий поведения, проверке их
        эффективности, распознаванию скрытых причин действий и повторяющихся
        событий. Игровая форма психологической помощи помогает найти оптимальные
        решения для быстрого достижения цели, помогает преодолеть кризисы,
        трудности и сложные ситуации, с которыми человеку приходится
        сталкиваться в современном мире.
      </p>
      <p className={styles.articles__pharagraph}>
        <b>Психологическая игра для консультации</b> – это новый тренд и новое
        результативное направление работы, экономия времени и средств, успешный
        инструмент поиска решений и инструмент личностного роста и саморазвития.
      </p>
    </div>
  );
};
